import { useSyncExternalStore } from 'react';

const QUERY = '(pointer: coarse)';

function coarse(): boolean {
  try { return typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(QUERY).matches; }
  catch { return false; }
}

function subscribe(listener: () => void): () => void {
  if (typeof window === 'undefined' || !window.matchMedia) return () => undefined;
  const media = window.matchMedia(QUERY);
  media.addEventListener('change', listener);
  return () => media.removeEventListener('change', listener);
}

/**
 * Whether the main pointer is a finger (a phone or a tablet). The add menu offers the camera there
 * (owner, 4 October 2026); a computer's file picker would only open the files again.
 */
export function useTouchDevice(): boolean {
  return useSyncExternalStore(subscribe, coarse, () => false);
}
